import { date, isEmpty, showAlert } from '../../../lib/helpers';
import {
  dataSourceOnboardingList,
  dataListAccountStatus,
} from '../../../store/params';
import { headers, search } from './attributes';


export default {
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonDotsExt: [
        {
          link: 'exportItemParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    isFirstLoad: true,
    page: '1',
    options: {},
    headers,
    editedIndex: -1,
    search,
    filterValue: { source_onboarding: '', name: '', address: '', bcko: '', cmer: '', active_date: [], inactive_date: [], status: '' },
    searchBcko: '',
    searchCmer: '',
    bckoList: [],
    cmerList: [],
    loadingBcko: false,
    loadingCmer: false,
    selectedBckoId: '',
    selectedCmerId: '',
  }),

  computed: {
    filterConfig() {
      return [
        { key: 'source_onboarding', type: 'select', props: { label: 'Source Onboarding', items: dataSourceOnboardingList } },
        { key: 'name', type: 'textfield', props: { label: 'Nama Aggregator' } },
        { key: 'address', type: 'textfield', props: { label: 'Alamat Lengkap' } },
        {
          key: 'bcko',
          type: 'autocomplete',
          props: {
            label: 'Branch Code BC/KO',
            items: this.bckoList,
            loading: this.loadingBcko,
            itemText: 'display_text',
            itemValue: 'id',
            search: this.searchBcko,
          }
        },
        {
          key: 'cmer',
          type: 'autocomplete',
          props: {
            label: 'Merchant Category Segment',
            items: this.cmerList,
            loading: this.loadingCmer,
            itemText: 'display_text',
            itemValue: 'id',
            search: this.searchCmer,
          }
        },
        { key: 'active_date', type: 'daterange', props: { label: 'Tanggal Active', includeToday: true } },
        { key: 'inactive_date', type: 'daterange', props: { label: 'Tanggal Inactive', includeToday: true } },
        { key: 'status', type: 'select', props: { label: 'Status', items: dataListAccountStatus } },
      ];
    },
    flashErrorMessage() {
      return this.$store.state.client.aggregator.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.client.aggregator.flashError;
      },
      set() {
        this.$store.commit('client/aggregator/setFlashErrorMessage', '');
      },
    },

    loading() {
      return this.$store.state.client.aggregator.loading;
    },
    allData() {
      return this.$store.state.client.aggregator.allAggregators;
    },
    totalData() {
      return this.$store.state.client.aggregator.totalAggregators;
    },
    totalPage() {
      return this.$store.state.client.aggregator.totalPage;
    },
    filterAllow() {
      return (
        isEmpty(this.search.source_onboarding) &&
        isEmpty(this.search.name) &&
        isEmpty(this.search.mobile_phone) &&
        isEmpty(this.search.address) &&
        isEmpty(this.search.bcko) &&
        isEmpty(this.search.cmer) &&
        isEmpty(this.search.status) &&
        this.search.active_date.length < 1 &&
        this.search.inactive_date.length < 1
      );
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('client/aggregator/clearAggregators');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },

    searchBcko(val, oldVal) {
      if (!val && !oldVal) return;
      if (this.isSelectedDisplayText('bcko', val)) return;
      this.debouncedFetchBcko(val || '');
    },

    searchCmer(val, oldVal) {
      if (!val && !oldVal) return;
      if (this.isSelectedDisplayText('cmer', val)) return;
      this.debouncedFetchCmer(val || '');
    },
  },

  created() {
    this.debouncedFetchBcko = this.createDebounced(this.fetchBckoList, 300);
    this.debouncedFetchCmer = this.createDebounced(this.fetchCmerList, 300);
  },

  async mounted() {
    this.fetchBckoList();
    this.fetchCmerList();
  },

  methods: {
    baseFilterData(newSearch) {
      this.search.source_onboarding = newSearch.source_onboarding || '';
      this.search.name = newSearch.name || '';
      this.search.address = newSearch.address || '';
      this.search.bcko = newSearch.bcko || '';
      this.search.cmer = newSearch.cmer || '';
      this.search.active_date = newSearch.active_date || [];
      this.search.inactive_date = newSearch.inactive_date || [];
      this.search.status = newSearch.status || '';
      this.options.page = 1;
      this.getData();
    },
    updateSearch(newSearch) {
      this.baseFilterData(newSearch);
    },
    showType(newSearch) {
      this.baseFilterData(newSearch);
    },
    isEmpty,

    clearSearch() {
      this.search.source_onboarding = '';
      this.search.name = '';
      this.search.address = '';
      this.search.bcko = '';
      this.search.cmer = '';
      this.search.status = '';
      this.search.active_date = [];
      this.search.inactive_date = [];
      this.searchBcko = '';
      this.searchCmer = '';
      this.selectedBckoId = '';
      this.selectedCmerId = '';
      this.$nextTick(() => {
        this.$router.push({ query: {} });
        this.$store.commit('client/aggregator/clearAggregators');
      });
    },

    getData() {
      if (this.filterAllow) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'One on the field need to be filled !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('client/aggregator/clearAggregators');
      } else {

        this.$store.commit('client/aggregator/setFlashErrorMessage', '');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('client/aggregator/fetchAggregators', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    viewListSubMerchant(item) {
      this.$router.push({
        path: `/client/aggregator/${item.id}/sub-merchant`,
      });
    },

    exportItem() {
      if (this.filterAllow) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Data is empty !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('client/aggregator/clearAggregators');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('client/aggregator/exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          view: 'aggregator',
          IDAggregator: '',
          IDMerchant: '',
        });
      }
    },

    async fetchBckoList(keyword = '') {
      this.loadingBcko = true;
      const result = await this.$store.dispatch('bckoShared/getBcko', { keyword, showAll: true, limit: 9999 });
      if (result.success) {
        this.bckoList = result.data.map(item => ({
          ...item,
          display_text: `${item.branch_code_bcko} - ${item.outlet_name}`,
        }));
      }
      this.loadingBcko = false;
    },

    async fetchCmerList(keyword = '') {
      this.loadingCmer = true;
      const result = await this.$store.dispatch('cmerShared/getCmer', { keyword, showAll: true, limit: 9999 });
      if (result.success) {
        this.cmerList = result.data.map(item => ({
          ...item,
          display_text: `${item.code} - ${item.definition}`,
        }));
      }
      this.loadingCmer = false;
    },

    handleFilterSearchInput(payload) {
      const { key, value } = payload || {};
      if (key === 'bcko') {
        this.searchBcko = value;
      } else if (key === 'cmer') {
        this.searchCmer = value;
      }
    },

    handleFilterValueChange(payload) {
      const { key, value } = payload || {};
      if (key === 'bcko') {
        this.selectedBckoId = value || '';
      } else if (key === 'cmer') {
        this.selectedCmerId = value || '';
      }
    },

    isSelectedDisplayText(field, val) {
      const selectedId = field === 'bcko' ? this.selectedBckoId : this.selectedCmerId;
      if (!selectedId || !val) return false;
      const list = field === 'bcko' ? this.bckoList : this.cmerList;
      const selected = list.find(item => item.id === selectedId);
      return !!(selected && selected.display_text === val);
    },

    createDebounced(fn, delay) {
      let timer = null;
      return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};